"use client";

import React, { useMemo } from "react";
import Link, { LinkProps } from "next/link";
import { getUri, getUriQuery } from "@/utils/url";
import { isString } from "@/utils/is";
import useUtm from "@/hooks/useUtm";

export interface CustomLinkProps
  extends LinkProps,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>,
    React.RefAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
}

const CustomLink: React.FC<CustomLinkProps> = (props) => {
  const { children, href, target, ...others } = props;

  const { utmParams } = useUtm();

  const _href = useMemo(() => {
    if (isString(href)) {
      const [path, search] = href.split("?");
      const hrefSearchParams = getUriQuery(search ?? "");
      return getUri(path, { ...utmParams, ...hrefSearchParams });
    }

    return href;
  }, [utmParams, href]);

  const isBlank = useMemo(() => {
    if (target === "_blank") {
      return true;
    }
    return false;
  }, [target]);

  return (
    <Link
      href={_href}
      target={target}
      {...(isBlank && { rel: "noopener noreferrer" })}
      {...others}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
